import _ = require('underscore');

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../datasource/models/IDataSourceInfo';
import { EntityActionNames, IEntityAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import {
  hasExtractOnlyDatasource,
  hasFileBasedDatasource,
  isAnyVirtualConnectionDatasource,
  isLegalForExtractMoveToTheWeb,
  isSingleDatasourceWithExtract,
  isSingleLiveDatasource
} from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IExtractConvertAction } from '../../../spacesPlatform/models/actionNames';
import { selectSpaceInfo } from '../../../spacesPlatform/selectors/SpaceInfoSelectors';
import { isDatasourceSpace, SpaceInfo } from '../../../spacesPlatform/state/SpaceInfo';
import { changeExtractDsToLive } from '../../actions/ChangeExtractDsToLiveAction';

export const ChangeExtractDsToLiveAction: IEntityAction<IDataSourceDetailInfo, IExtractConvertAction> = {
  name: EntityActionNames.ChangeExtractDsToLive,
  translateName: Messages.changeExtractDsToLiveAction,
  isVisible: (targetItems: IDataSourceDetailInfo[], state: AppState) => {
    if(!isLegalForExtractMoveToTheWeb(targetItems)){
      return false;
    }
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    return isDatasourceSpace(spaceInfo) && _.any(targetItems, (targetItem) => targetItem.contentType === 'datasource');
  },
  isClickable: (availableActions: IExtractConvertAction, targetItems: IDataSourceDetailInfo[], state: AppState) => {
    return !(availableActions && !availableActions.extractsToLive) &&
      !hasFileBasedDatasource(targetItems) &&
      !hasExtractOnlyDatasource(targetItems) &&
      isSingleDatasourceWithExtract(targetItems) &&
      !isAnyVirtualConnectionDatasource(targetItems);
  },
  isChecked: (availableActions: {}, targetItems: IDataSourceDetailInfo[], state: AppState) => {
    return isSingleLiveDatasource(targetItems);
  },
  createReduxAction: (dataSources: IDataSourceDetailInfo[]) => changeExtractDsToLive(dataSources)
};
